import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import * as Filter from "../utils/Filter";

export default class FilterV2 {
    constructor(dom) {
        window.addEventListener("resize", () => this.resize());
        this.dom = dom
        this.loading = false;

        this.multi = false
        this.filterValues = {};
        this.filterType = null;

        this.filterNames = {};
    }

    init() {
        this.multi = this.dom.dataset.multi === 'true' ? true : false;
        this.filterType = this.dom.dataset.type;

        // set initial filter values from active links
        this.dom.querySelectorAll('.dropdown-item[data-filter-value]').forEach(link => {
            const filterType = link.closest('ul[data-filter-type]').dataset.filterType;
            const filterValue = link.dataset.filterValue;
            const filterName = link.textContent.trim();

            if (!this.filterNames[filterType]) {
                this.filterNames[filterType] = {};
            }
            this.filterNames[filterType][filterValue] = filterName;

            if (link.classList.contains('active')) {
                if (!this.filterValues[filterType]) {
                    this.filterValues[filterType] = [];
                }
                this.filterValues[filterType].push(filterValue);
            }
        });

        this.dom.querySelectorAll('.dropdown-item[data-filter-value]').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.applyFilter(link);
            });
        });

        this.selectedFiltersContainer = this.dom.querySelector('.selected-filters .tags');
        this.updateSelectedFilterTags();
    }

    updateActiveLinks() {
        this.dom.querySelectorAll('.dropdown-item[data-filter-value]').forEach(link => {
            const filterGroup = link.closest('ul[data-filter-type]').dataset.filterType;
            const filterValue = link.dataset.filterValue;

            if (this.filterValues[filterGroup] && this.filterValues[filterGroup].includes(filterValue)) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    updateSelectedFilterTags() {
        if (!this.selectedFiltersContainer) return;

        this.selectedFiltersContainer.innerHTML = '';

        for (const group in this.filterValues) {
            this.filterValues[group].forEach(value => {
                const name = this.filterNames[group]?.[value] || value;

                const tagEl = document.createElement('div');
                tagEl.className = 'tag';
                tagEl.dataset.filterType = group;
                tagEl.dataset.filterValue = value;
                tagEl.innerHTML = `<span class="filter-name">${name}</span> <span class="close-icon"></span>`;

                this.selectedFiltersContainer.appendChild(tagEl);

                tagEl.addEventListener('click', () => {
                    const link = this.dom.querySelector(`.dropdown-item[data-filter-value="${value}"]`);
                    if (link) {
                        this.applyFilter(link);
                    }
                });
            });
        }
    }

    applyFilter(link) {
        if (this.loading) return;

        const filterValue = link.dataset.filterValue;
        const filterGroup = link.closest('ul[data-filter-type]').dataset.filterType;

        this.loading = true;
        this.multi = this.dom.dataset.multi === 'true' ? true : false;
        // 1. Update this.filterValues
        if (this.multi) {
            if (!this.filterValues[filterGroup]) {
                this.filterValues[filterGroup] = [];
            }
            const index = this.filterValues[filterGroup].indexOf(filterValue);
            if (index > -1) {
                this.filterValues[filterGroup].splice(index, 1); // Remove value
            } else {
                this.filterValues[filterGroup].push(filterValue); // Add value
            }
            if (this.filterValues[filterGroup].length === 0) {
                delete this.filterValues[filterGroup];
            }
        } else {
            // Version 1: If it's the currently selected one, deselect it
            // if (this.filterValues[filterGroup] && this.filterValues[filterGroup][0] === filterValue) {
            //     delete this.filterValues[filterGroup];
            // } else {
            //     // Otherwise, select it as the only one
            //     this.filterValues[filterGroup] = [filterValue];
            // }

            // Version 2: Clear all first, then select if it wasn't the selected one
            const isSelected = this.filterValues[filterGroup] && this.filterValues[filterGroup][0] === filterValue;

            // Clear all filters first for single-selection mode
            this.filterValues = {};

            // If it wasn't the selected one, or if it was from a different group, select it now.
            if (!isSelected) {
                this.filterValues[filterGroup] = [filterValue];
            }
            // If it was selected, it's now deselected because we cleared everything.
        }

        // 2. Update UI from this.filterValues
        this.updateActiveLinks();
        this.updateSelectedFilterTags();

        // 3. Update URL
        this.updateURL();

        // 4. Prepare options for AJAX request
        this.fetchData();
    }

    updateURL() {
        const url = new URL(window.location);
        const currentParams = new URLSearchParams(url.search);
        
        // Get all keys from current params and this.filterValues to know what to clear
        const allKeys = new Set([...Object.keys(this.filterValues), ...Array.from(currentParams.keys())]);

        allKeys.forEach(key => {
            if (this.filterValues[key]) {
                url.searchParams.set(key, this.filterValues[key].join(','));
            } else {
                // Only delete if it's a filter-related param.
                if (this.dom.querySelector(`ul[data-filter-type="${key}"]`)) {
                    url.searchParams.delete(key);
                }
            }
        });

        window.history.pushState({}, '', url);
    }

    fetchData() {
        const options = {};
        for (const key in this.filterValues) {
            options[key] = this.filterValues[key].join(',');
        }

        options['type'] = this.filterType;

        switch (this.filterType) {
            case 'news':
            case 'projects':
            case 'featuredProjects':
                options['related'] = this.dom.dataset.related ? this.dom.dataset.related : '';
                break;
        }

        // 4. Call filter
        Filter.filter(this.filterType, options, (response) => {
            this.loading = false;
        });

    }

    initResponsiveHelper() {

    }

    resize() {
    }

}
